module.exports = __webpack_public_path__ + "static/media/Avatar_principal.e7ec9683.svg";